<template>
  <div>
    <title>销售人员券卡统计</title>
    <section class="goodsBox">
      <!--S 公用头部切换-->
      <!-- <CardStatisticsTab :cateType="3"></CardStatisticsTab> -->
      <!--E 公用头部切换-->
      <!--S 检索-->
      <el-form :model="searchGLForm" inline class="noBtmForm">
        <el-form-item label="出库时间">
          <!-- S 双日期选择器 -->
          <TwoDatePicker
            :noQuick="1"
            @twoDateObtain="twoDateReceive"
            :startvaldate="searchGLForm.paiTime.length>0?searchGLForm.paiTime[0]:''"
            :endvaldate="searchGLForm.paiTime.length>0?searchGLForm.paiTime[1]:''" >
          </TwoDatePicker>
          <!-- E 双日期选择器 -->
        </el-form-item>
        <el-form-item label="激活时间">
          <!-- S 双日期选择器 -->
          <TwoDatePicker
            :noQuick="1"
            @twoDateObtain="actDateReceive"
            :startvaldate="searchGLForm.actTime.length>0?searchGLForm.actTime[0]:''"
            :endvaldate="searchGLForm.actTime.length>0?searchGLForm.actTime[1]:''" >
          </TwoDatePicker>
          <!-- E 双日期选择器 -->
        </el-form-item>
        <el-form-item label="手机号码">
            <el-input v-model="searchGLForm.mphone" placeholder="请输入内容" clearable maxlength="16"></el-input>
        </el-form-item>
        <el-form-item label="销售人员">
          <el-select v-model="searchGLForm.flowcode" class="filterMultiIpt" popper-class="scrollSelect" multiple collapse-tags filterable placeholder="请选择" clearable :filter-method="filterFlow" @focus="getFlowList" @visible-change="closeFlowName">
            <div class="optionBox" :class="{'showPage':flowList.length<=30}">
              <el-option
                v-for="item in flowList"
                :key="item.membercode"
                :label="item.membername"
                :value="item.membercode">
              </el-option>
            </div>
            <el-pagination
              @current-change="flowCurrentChange"
              :current-page="flowCurrent"
              :page-sizes="[30]"
              :page-size="30"
              layout="pager"
              :total="flowBean.totalnum" v-show="flowBean.totalnum>30"
              small>
            </el-pagination>
          </el-select>
        </el-form-item>
        <el-form-item>
        <!-- 选择会员弹窗参照 订单中心-》到店自提 -->
          <el-button type="primary" @click="querySubmit">查询</el-button>
          <el-button type="primary" plain @click="exportShow=true" v-show="!exportShow">导出</el-button>
          <el-button type="success" v-show="exportShow" icon="el-icon-check" round @click="toPrinting(0)">检索导出</el-button>
          <el-button type="success" v-show="exportShow" icon="el-icon-check" round @click="toPrinting(1)">勾选导出</el-button>
          <el-button type="danger" v-show="exportShow" icon="el-icon-close" round @click="closeExport">取消</el-button>
        </el-form-item>
      </el-form>
      <!-- 注意：没有小灯泡提示的时候，要加类名pb20,有的时候就不要加 -->
      <p class="pb20">
        <el-button v-for="(item,index) in timeLimit" :key="index"  size="small" :type="index == searchGLForm.current?'primary':''" @click="dateQuery(index)">{{item}}</el-button>
      </p>
      <!--E 检索-->
      <div class="gsListTable individualiz">
        <!--S 商品列表-->
        <el-table ref="gsTable" class="gsTable comTable borderTable" border :data="cardStatisticsList" :maxHeight="tableHeight" @selection-change="handleSelectionChange" v-loading="loading">
          <el-table-column v-if="exportShow" type="selection" width="80"></el-table-column>
          <el-table-column type="index" label="序号" width="80" fixed="left"></el-table-column>
          <el-table-column label="销售人员名称" min-width="200">
            <template slot-scope="scope">
              <p class="textHiden" :title="scope.row.flowname">{{scope.row.flowname}}</p>
            </template>
          </el-table-column>
          <el-table-column label="手机号码" min-width="150">
            <template slot-scope="scope">
              <p class="textHiden" :title="scope.row.mphone">{{scope.row.mphone | empty}}</p>
            </template>
          </el-table-column>
          <el-table-column label="销售总数" prop="lnum" min-width="150">
            <template slot-scope="scope">
              <a @click="toStatisticsDetail(-1,scope.row)" tag="p" class="hand iconhand" title="点击查看详情" v-if="scope.row.lnum!='0'&&scope.row.lnum!='~'">{{scope.row.lnum}}</a>
              <p class="textHiden" v-else>{{scope.row.lnum}}</p>
            </template>
          </el-table-column>
          <el-table-column label="未提货数量" prop="lwth" min-width="150">
            <template slot-scope="scope">
              <a @click="toStatisticsDetail(1,scope.row)" tag="p" class="hand iconhand" title="点击查看详情" v-if="scope.row.lwth!='0'&&scope.row.lwth!='~'">{{scope.row.lwth}}</a>
              <p class="textHiden" v-else>{{scope.row.lwth}}</p>
            </template>
          </el-table-column>
          <el-table-column label="已提货数量" prop="lyth" min-width="150">
            <template slot-scope="scope">
              <a @click="toStatisticsDetail(3,scope.row)" tag="p" class="hand iconhand" title="点击查看详情" v-if="scope.row.lyth!='0'&&scope.row.lyth!='~'">{{scope.row.lyth}}</a>
              <p class="textHiden" v-else>{{scope.row.lyth}}</p>
            </template>
          </el-table-column>
          <el-table-column label="暂停提货数量" prop="lztth" min-width="150">
            <template slot-scope="scope">
              <a @click="toStatisticsDetail(4,scope.row)" tag="p" class="hand iconhand" title="点击查看详情" v-if="scope.row.lztth!='0'&&scope.row.lztth!='~'">{{scope.row.lztth}}</a>
              <p class="textHiden" v-else>{{scope.row.lztth}}</p>
            </template>
          </el-table-column>
          <!-- <el-table-column label="每种券卡状态对应数量" align="center">
            <el-table-column label="未激活" min-width="120">
              <template slot-scope="scope">
                <a @click="toStatisticsDetail(0,scope.row)" tag="p" class="hand iconhand" title="点击查看详情" v-if="scope.row.lwjh!='0'&&scope.row.lwjh!='~'">{{scope.row.lwjh}}</a>
                <p class="textHiden" v-else>{{scope.row.lwjh}}</p>
              </template>
            </el-table-column>
            <el-table-column label="未提货" min-width="120">
              <template slot-scope="scope">
                <a @click="toStatisticsDetail(1,scope.row)" tag="p" class="hand iconhand" title="点击查看详情" v-if="scope.row.lwth!='0'&&scope.row.lwth!='~'">{{scope.row.lwth}}</a>
                <p class="textHiden" v-else>{{scope.row.lwth}}</p>
              </template>
            </el-table-column>
            <el-table-column label="部分提货" min-width="120">
              <template slot-scope="scope">
                <a @click="toStatisticsDetail(2,scope.row)" tag="p" class="hand iconhand" title="点击查看详情" v-if="scope.row.lbfth!='0'&&scope.row.lbfth!='~'">{{scope.row.lbfth}}</a>
                <p class="textHiden" v-else>{{scope.row.lbfth}}</p>
              </template>
            </el-table-column>
            <el-table-column label="已提货" min-width="120">
              <template slot-scope="scope">
                <a @click="toStatisticsDetail(3,scope.row)" tag="p" class="hand iconhand" title="点击查看详情" v-if="scope.row.lyth!='0'&&scope.row.lyth!='~'">{{scope.row.lyth}}</a>
                <p class="textHiden" v-else>{{scope.row.lyth}}</p>
              </template>
            </el-table-column>
            <el-table-column label="暂停提货" min-width="120">
              <template slot-scope="scope">
                <a @click="toStatisticsDetail(4,scope.row)" tag="p" class="hand iconhand" title="点击查看详情" v-if="scope.row.lztth!='0'&&scope.row.lztth!='~'">{{scope.row.lztth}}</a>
                <p class="textHiden" v-else>{{scope.row.lztth}}</p>
              </template>
            </el-table-column>
            <el-table-column label="已回收" min-width="120">
              <template slot-scope="scope">
                <a @click="toStatisticsDetail(5,scope.row)" tag="p" class="hand iconhand" title="点击查看详情" v-if="scope.row.lhs!='0'&&scope.row.lhs!='~'">{{scope.row.lhs}}</a>
                <p class="textHiden" v-else>{{scope.row.lhs}}</p>
              </template>
            </el-table-column>
            <el-table-column label="已作废" min-width="120">
              <template slot-scope="scope">
                <a @click="toStatisticsDetail(6,scope.row)" tag="p" class="hand iconhand" title="点击查看详情" v-if="scope.row.lzf!='0'&&scope.row.lzf!='~'">{{scope.row.lzf}}</a>
                <p class="textHiden" v-else>{{scope.row.lzf}}</p>
              </template>
            </el-table-column>
            <el-table-column label="回收折现" min-width="120">
              <template slot-scope="scope">
                <a @click="toStatisticsDetail(8,scope.row)" tag="p" class="hand iconhand" title="点击查看详情" v-if="scope.row.lhszx!='0'&&scope.row.lhszx!='~'">{{scope.row.lhszx}}</a>
                <p class="textHiden" v-else>{{scope.row.lhszx}}</p>
              </template>
            </el-table-column>
          </el-table-column> -->
          <template slot="empty">
            <div class="noData"><span>暂无数据</span></div>
          </template>
        </el-table>
        <!--E 商品列表-->
      </div>
      <!-- S 分页 -->
      <Page :pageTotal="pagebBean.totalnum" :currentPage="currentPage" @nowPageParam="updatePage"></Page>
      <!-- S 分页 -->
    </section>
  </div>
</template>
<script>
import { MessageBox } from "element-ui";
import api from '@/apis/api.js';
export default {
    name:'CardFlowStatisticsList',
    data () {
        return {
            cateType:2, //当前选中菜单
            searchGLForm:{
                flowcode: [], 
                paiTime:[],
                current:0,//当前检索时限,0：全部，1：本年度，2：本季度，3：本月 4：本周
                mphone: '', // 手机号查询
                actTime: [], // 激活时间段
            },
            timeLimit:['全部','本年度','本季度','本月','本周'],//检索时限
            tableHeight: window.innerHeight*.8, //表格动态高度
            cardStatisticsList: [], // 统计数据列表
            pageSize: 30, // 每页展示的条数
            currentPage: 1, // 当前请求的页数
            pagebBean: {
                totalnum: 0,
            }, // 获取到的列表分页信息
            flowList: [], // 流向方列表
            queryFlowname: '', // 检索的流向名称
            flowCurrent: 1, // 请求的商品的页面
            flowBean: { // 返回的商品分页信息
                totalnum: 0,
            },
            exportShow: false, // 是否为导出操作
            multipleSelection: [], // 选中的列表数据
            printingShow: true, // 防止多次点击导出按钮
            loading: false, // 加载中弹窗显示和隐藏
            patchName: '', // 获取上一个页面的name
            pFlowcodes: '', // 上级的门店编号
        }
    },
    filters: {

    },
    components: {
      CardStatisticsTab: resolve => require(["@/components/StatisticsFolder/CardStatisticsTab.vue"],resolve), //头部tab组件
      TwoDatePicker: resolve => require(["@/components/common/TwoDatePicker.vue"], resolve), // 双日期选择器组件
      Page: resolve => require(["@/components/common/Page.vue"], resolve),
    },
    // ============================================== 监听 ==============================================
    watch: {
      '$route'(to,from) {
        this.patchName = from.name;
      }
    },
    // ============================================== 方法 ==============================================
    methods: {
      //动态获取表格高度
      getHeight() {
          let tbHeight = this.$refs.gsTable.$el.offsetTop; //顶部检索条件占据的高度
          this.tableHeight = window.innerHeight - tbHeight - 130; 
      },
      // 接收选中的日期
      twoDateReceive(info) {
          this.searchGLForm.current = 0;
          if(info&&info.length>0) {
              this.searchGLForm.paiTime[0] = info[0];
              this.searchGLForm.paiTime[1] = info[1];
          } else {
              this.searchGLForm.paiTime = [];
          }
      },
      // 接收选中的激活日期
      actDateReceive(info) {
          if(info&&info.length>0) {
              this.searchGLForm.actTime[0] = info[0];
              this.searchGLForm.actTime[1] = info[1];
          } else {
              this.searchGLForm.actTime = [];
          }
      },
      // 固定日期检索
      dateQuery(type) {
          this.searchGLForm.current = type;
          let start = new Date();
          let end = new Date();
          if(type == 0) {
              this.searchGLForm.paiTime = [];
          } else if(type == 1) {
              let nian = start.getFullYear();
              // start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
              this.searchGLForm.paiTime[0] = `${nian}-01-01`;
              this.searchGLForm.paiTime[1] = end;
          } else if(type == 2) {
              // start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              let nian = start.getFullYear();
              let yue = start.getMonth()+1;
              if(yue<4) {
              yue = '01';
              } else if(yue<7) {
              yue = '04';
              } else if(yue<10) {
              yue = '07';
              } else {
              yue = '10';
              }
              this.searchGLForm.paiTime[0] = nian + '-' + yue + '-' + '01';
              this.searchGLForm.paiTime[1] = end;
          } else if(type == 3) {
              // start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              let nian = start.getFullYear();
              let yue = start.getMonth()+1;
              this.searchGLForm.paiTime[0] = nian + '-' + (yue>10?yue:`0${yue}`) + '-' + '01';
              this.searchGLForm.paiTime[1] = end;
          } else if(type == 4) {
              let day = start.getDay() || 7
              if(day) {
              day = day - 1;
              } else {
              day = 0;
              }
              start.setTime(start.getTime() - 3600 * 1000 * 24 * day);
              this.searchGLForm.paiTime[0] = start;
              this.searchGLForm.paiTime[1] = end;
          };
          this.querySubmit();
      },
      // 查询确认事件
      querySubmit() {
          this.getSmallStoresCardstatisticsList();
      },
      // 获取券卡统计记录
      getSmallStoresCardstatisticsList() {
          this.loading = true;
          let flowcodes = '';
          if(this.searchGLForm.flowcode.length>0) {
              this.searchGLForm.flowcode.forEach(item => {
              if(flowcodes) {
                  flowcodes = flowcodes + ',' + item;
              } else {
                  flowcodes = item;
              }
              })
          }
          let cardParams = {
              flowcode: flowcodes,
              startdate: this.searchGLForm.paiTime.length>0?this.dateTime(this.searchGLForm.paiTime[0]):'',
              enddate: this.searchGLForm.paiTime.length>0?this.dateTime(this.searchGLForm.paiTime[1]):'',
              actstartdate: this.searchGLForm.actTime.length>0?this.dateTime(this.searchGLForm.actTime[0]):'',
              actenddate: this.searchGLForm.actTime.length>0?this.dateTime(this.searchGLForm.actTime[1]):'',
              mphone: this.searchGLForm.mphone,
              pflowcode: this.pFlowcodes,
              pageparam: {
                  pagesize: this.pageSize, //每页条数
                  currentpage: this.currentPage, //当前页数
                  isnewcomp: 1 //是否需要重新统计页数
              }
          }
          api.GET_SMALLSTORESCARDSTATISTICSLIST(cardParams).then(res => {
              this.toTableTop('gsTable');
              this.loading = false;
              if(res.data.status == "200") {
                  if(res.data.data && res.data.data != "null") {
                      this.cardStatisticsList = res.data.data;
                  } else {
                      this.cardStatisticsList = [];
                  }
              }
              this.pagebBean = res.data.pagebean;
          }).catch(res => {
              this.loading = false;
          })
      },
      // 接收分页信息
      updatePage(size,num) {
        this.pageSize = size;
        this.currentPage = num;
        this.getSmallStoresCardstatisticsList();
      },
      // 查看券卡统计信息
      toStatisticsDetail(type,info) {
        let ticsQueryInfo = {
          eleType: type,
          paiTime: this.searchGLForm.paiTime,
          flowcode: info.flowcode,
          actTime: this.searchGLForm.actTime,
        }
        sessionStorage.setItem('ticsQueryInfo',JSON.stringify(ticsQueryInfo));
        this.$router.push({
          name: '兑换礼券统计详情',
          query: {
            objtype: '7'
          }
        })
      },
      // 获取流向方列表
      getFlowList() {
        let flowParams = {
          flowcode: this.pFlowcodes,
          keyword: this.queryFlowname,
          isShowSelf: 0,
          pageparam: {
            pagesize: 30, //每页条数
            currentpage: this.flowCurrent, //当前页数
            isnewcomp: 1 //是否需要重新统计页数
          }
        }
        api.GET_SMALLSTORESFLOWINFO(flowParams).then(res => {
          if(res.data.status == "200") {
          if(res.data.data && res.data.data != 'null') {
            this.flowList = res.data.data;
          } else {
            this.flowList = [];
          }
          this.flowBean = res.data.pagebean;
          }
        })
      },
      // 规格分页
      flowCurrentChange(val) {
        this.flowCurrent = val;
        this.getFlowList();
      },
      // 搜索规格方法
      filterFlow(item) {
        this.queryFlowname = item;
        this.flowCurrent = 1;
        this.getFlowList();
      },
      // 清除筛选的名称
      closeFlowName(val) {
        if(!val) {
          this.queryFlowname = '';
          this.flowCurrent = 1;
          // this.getFlowList();
        }
      },
      //表格多选选中行复制
      handleSelectionChange(val) { 
        this.multipleSelection = val;
      },
      // 取消导出
      closeExport() {
        this.multipleSelection = [];
        this.$refs.gsTable.clearSelection(); // 清空选中列表数据
        this.exportShow = false;
      },
      // 打印操作确认事件
      toPrinting(type) {
        if(this.printingShow) {
            let flowcodes = '';
            if(this.searchGLForm.flowcode.length>0) {
                this.searchGLForm.flowcode.forEach(item => {
                    if(flowcodes) {
                        flowcodes = flowcodes + ',' + item;
                    } else {
                        flowcodes = item;
                    }
                })
            }
            let queryParams = {
                flowcode: flowcodes,
                startdate: this.searchGLForm.paiTime.length>0?this.dateTime(this.searchGLForm.paiTime[0]):'',
                enddate: this.searchGLForm.paiTime.length>0?this.dateTime(this.searchGLForm.paiTime[1]):'',
                actstartdate: this.searchGLForm.actTime.length>0?this.dateTime(this.searchGLForm.actTime[0]):'',
                actenddate: this.searchGLForm.actTime.length>0?this.dateTime(this.searchGLForm.actTime[1]):'',
                mphone: this.searchGLForm.mphone,
                pflowcode: this.pFlowcodes,
            }
            if(type == 1) {
                if(this.multipleSelection&&this.multipleSelection.length>0) {
                    queryParams.exceltype = 1;
                    let alltotales = '';
                    this.multipleSelection.forEach(item => {
                        if(alltotales!=='') {
                            alltotales = alltotales + ',' + item.flowcode;
                        } else {
                            alltotales = item.flowcode;
                        }
                    })
                    this.loading = true;
                    this.printingShow = false;
                    queryParams.alltotale = alltotales;
                    this.exportStatistics(queryParams);
                } else {
                    this.$message({
                    type: 'warning',
                    message: '请至少勾选一项！'
                    })
                }
            } else {
                this.loading = true;
                this.printingShow = false;
                queryParams.exceltype = 0;
                this.exportStatistics(queryParams);
            }
        }
      },
      // 导出数据列表
      exportStatistics(exportParams) {
          api.GET_URLFORSMALLSTORESCARDSTATISTICSLIST(exportParams).then(res => {
              if(res.data.status == "200") {
                  if(res.data.data && res.data.data.indexOf('http')!=-1) {
                      window.location.href = res.data.data;
                      this.$message({
                          type: 'success',
                          message: res.data.message
                      })
                      this.closeExport();
                  } else {
                      MessageBox.confirm(`${res.data.data}`, '提示', {
                      confirmButtonText: '确定',
                      showCancelButton: false,
                      type: 'success'
                      }).then(() => {
                          this.closeExport();
                      }).catch(() => {})
                  }
              } else {
                  this.$message({
                      type: 'error',
                      message: res.data.message
                  })
              }
              this.printingShow = true;
              this.loading = false;
          }).catch(res => {
              this.printingShow = true;
              this.loading = false;
          })
      },
    },
    created() {
      //页面浏览器视窗变化绑定resize事件
      window.addEventListener("resize", this.getHeight);
    },
    mounted () {
      if(localStorage.getItem('userInfoMd')) {
        this.pFlowcodes = JSON.parse(localStorage.getItem('userInfoMd')).flowcode;
      }
      // 固定日期检索
      this.dateQuery(0)
      // // 获取券卡统计记录
      // this.getSmallStoresCardstatisticsList();
      //在dom渲染之后
      setTimeout(()=>{
        this.getHeight();
      },200)

    },
    computed: {},
    destroyed(){ 
      window.removeEventListener('resize', this.getHeight); //销毁监听浏览器视窗变化
    },
    activated() {
      if(this.patchName != '兑换礼券统计详情') {
        if(this.patchName) {
          Object.assign(this.$data, this.$options.data());
          if(localStorage.getItem('userInfoMd')) {
            this.pFlowcodes = JSON.parse(localStorage.getItem('userInfoMd')).flowcode;
          }
          this.searchGLForm = {
              flowcode:'', 
              paiTime:[],
              current:1,//当前检索时限,0：全部，1：本年度，2：本季度，3：本月 4：本周
              actTime: [], // 激活时间段
          }
          this.pageSize = 30; // 每页展示的条数
          this.currentPage = 1; // 当前请求的页数
          // 固定日期检索
          this.dateQuery(0)
          // // 获取券卡统计记录
          // this.getSmallStoresCardstatisticsList();
          //在dom渲染之后
          setTimeout(()=>{
            this.getHeight();
          },200)
        }
      }
    },
}
</script>
<style scoped>
@import '../../GoodsFolder/Css/style.css';
.pb20{margin-bottom: 20px;}
.goodsBox {padding:20px; height:calc(100% - 40px);}
.searchForm{padding-top: 64px;}
.gsTable em{
  display: inline-block;
  vertical-align: middle;
  height: 20px;
  width: 20px;
  color:
  #fff;
  border-radius: 50%;
  text-align: center;
  font-size: 12px;
  line-height: 20px;
  margin-left: 10px;
}
.gsTable .orange{background-color: #FF7018;}
.gsTable .blue{background-color: var(--main-color);}
.gsTable .iconhand::before {
  font-size: 20px;
  padding-right: 5px;
  display: inline-block;
  vertical-align: top;
}
.gsTable >>> .el-table__header .el-form-item {margin-bottom:0!important;}
.goodsUse {position:relative;height:36px;padding-right:15px;border-right:solid 1px #dcdfe6;}
.goodsUse em {position:absolute; left:0; top:-20px; font-size: 12px; color:#999;}
.gsTable.el-table >>> thead.is-group > tr:first-child th .cell{overflow: visible!important;}
.gsTable.el-table >>> thead.is-group > tr:nth-child(2) th .cell {color:#333;}
.gsTable.el-table >>> .el-table__body .el-checkbox {padding:20px;}
.gsTable.el-table >>> .el-table__header .el-checkbox {padding:0 20px;}
.gsTable >>> .el-dropdown-link {cursor: pointer; color: var(--main-color);}
.inlineMember {padding:0 10px; border:solid 1px #dcdfe6; height:38px; line-height:38px;}
.childView.takeLeft .inlineMember,.childView.helpRight .inlineMember {margin-top:0px;}
@media only screen and (max-width: 1700px) {
  .inlineMember {margin-top:10px;} 
}
.inlineMember a:first-child {position:relative; width:30px; height:30px; margin:3px 0; border-radius:50%; overflow: hidden; border:solid 1px #ebeef5; }
.inlineMember img {position:absolute; left:0; top:0; right:0; bottom:0; margin:auto; width:30px; }
.inlineMember * {display:inline-block; vertical-align: top; font-size: 14px;}
.inlineMember span {margin-right:10px;}
.inlineMember i {color:#999;}
.inlineMember em {max-width:150px;width:auto;}
.inlineMember .iconmale {font-size: 18px;color:var(--main-color);}
.inlineMember .iconfemale {font-size: 18px;color:#f56c6c;}
.goodsImg{
  display: inline-block;
  position: relative;
  width: 50px;
  height: 50px;
  border: solid 1px #dcdfe6;
  border-radius:100%;
  margin-right:10px;
}
.goodsImg img {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  max-width: 100%;
  border-radius: 50%;
}
.goodsCont h3{font-size:14px!important;font-weight:bold;}
.goodsCont p{font-size:12px;}
.goodsCont{width: calc(100% - 65px);}
.actShow {padding-top:10px; color:#999;  font-size: 12px;}
.actShow span {display:inline-block; margin-right:35px;}
.actShow span b {font-weight: 600; padding-right:5px;}
.gsTable .hand{cursor: pointer;font-size: 14px;}
.el-table>>>thead.is-group th{background: #f2f3f5!important;}
</style>



// WEBPACK FOOTER //
// src/views/StatisticsFolder/CardStatistics/SaleStaffStatisticsList.vue